import {
    Avatar,
    HStack,
    Text,
    VStack,
} from "@chakra-ui/react";

import Card from "./Card";

const partners = [
    {
        name: "Kabelo M.",
        referrals: 142,
        earnings: "P12k+",
    },
    {
        name: "Sipho N.",
        referrals: 98,
        earnings: "P9k+",
    },
    {
        name: "Lesedi D.",
        referrals: 74,
        earnings: "P7k+",
    },
];

const Leaderboard = () => {
    return (
        <Card>
            <Text
                fontWeight="700"
                fontSize="xl"
                mb={6}
            >
                Top Partners
            </Text>

            <VStack
                align="stretch"
                gap={5}
            >
                {partners.map(
                    (
                        partner,
                        index
                    ) => (
                        <HStack
                            key={partner.name}
                        >
                            <Text
                                w="20px"
                                fontWeight="700"
                            >
                                {index + 1}
                            </Text>

                           <Avatar.Root
                            size="md"
                            bg={index === 0 ? "#2453FF" : undefined}
                            color={index === 0 ? "white" : "grey"}
                        >
                            <Avatar.Fallback
                                bg="transparent"
                                fontWeight="700"
                            >
                                {partner.name
                                    .split(" ")
                                    .map((n) => n[0])
                                    .join("")}
                            </Avatar.Fallback>
                        </Avatar.Root>
                            <VStack
                                flex="1"
                                align="start"
                                gap={0}
                            >
                                <Text fontWeight="600">
                                    {
                                        partner.name
                                    }
                                </Text>

                                <Text
                                    color="gray.500"
                                    fontSize="sm"
                                >
                                    {
                                        partner.referrals
                                    }{" "}
                                    Referrals
                                </Text>
                            </VStack>

                            <Text
                                color="green.600"
                                fontWeight="700"
                            >
                                {
                                    partner.earnings
                                }
                            </Text>
                        </HStack>
                    )
                )}
            </VStack>
        </Card>
    );
};

export default Leaderboard;